/* eslint-disable import/no-unresolved */
import { IJointLifeAddendum } from "src/helpers/FormDetails/JointLifeAddendum/interfaces";
import * as types from "../../Types/jointLifeDetails";

export const setJointLifeAddendumDetails = (payload: IJointLifeAddendum) => ({
  type: types.SET_JOINT_LIFE_ADDENDUM_DETAILS,
  payload
});

export const setJointLifeCovidAndNriDetails = (payload: any) => ({
  type: types.SET_JOINT_LIFE_COVID_AND_NRI_DETAILS,
  payload
});

export const saveJointLifeAddendumDetails = (
  jointBinding: Record<string, any>,
  leadId: string
) => ({
  type: types.SAVE_JOINT_LIFE_ADDENDUM_DETAILS,
  payload: { jointBinding, leadId }
});

export const setJointPincodeData = (payload: { city: string; state: string }) => ({
  type: types.POPULATE_JOINT_PINOCODE_DATA,
  payload
});

export const setJointSubOccupationData = (payload: any) => ({
  type: types.SET_JOINT_SUB_OCCUPATION_DATA,
  payload
});

export const setJointCountry = (payload: any) => ({
  type: types.SET_JOINT_COUNTRY_NAME,
  payload
});

export const setJointCountryData = (payload: Record<string, any>) => ({
  type: types.SET_JOINT_COUNTRY_DATA,
  payload
});

export const setJointMasterData = (payload: any) => ({
  type: types.SET_JOINT_MASTER_DATA,
  payload
});

export const setJointReviewData = (payload: any) => ({
  type: types.SET_JOINT_REVIEW_DATA,
  payload
});

export const setJointFreezeData = (payload: Record<string, any>) => ({
  type: types.SET_JOINT_LIFE_FREEZE_DATA,
  payload
});

export const saveJointMemberId = (payload: string) => ({
  type: types.SAVE_JOINT_MEMBER_ID,
  payload
});
